export default __webpack_public_path__ + "static/media/placeholder-produtos-40-graus.3051aa1d.png";